// extracted by mini-css-extract-plugin
export default {"item":"TeamStatItem_item__I8mcI","teamName":"TeamStatItem_teamName__tkS9s","btns":"TeamStatItem_btns__v8plA","playBtn":"TeamStatItem_playBtn__8dx1P"};